module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-sit-b6c1d80d02511ddfb9f33e07c27bd266.png";